export const isChromeBrowser = (): boolean => {
  const ua = navigator.userAgent;
  const isChromium = !!(window as unknown as { chrome?: unknown }).chrome;
  const isEdge = ua.includes('Edg/');
  const isOpera = ua.includes('OPR/') || ua.includes('Opera');
  const isBrave = (navigator as unknown as { brave?: unknown }).brave !== undefined;
  const isIOSChrome = /CriOS\//.test(ua);
  const isAndroidWebView = /; wv\)/.test(ua);

  if (isEdge || isOpera || isBrave || isAndroidWebView) {
    return false;
  }
  return isIOSChrome || (isChromium && ua.includes('Chrome/'));
};
